// Note this needs to be a .js file because it gets loaded in the next.config.js file

/** @type {import("@/src/@types/Settings").ISiteConfig} */
const siteConfig = {
    id: "default",
    name: "Spot Pet Insurance",
    homeTitle: "Pet Insurance: Best In Breed Coverage",
    description:
        "Spot Pet Insurance is committed to helping dogs and cats live longer, healthier lives, by providing accident, illness & preventive care pet plans. Get a free quote.",
    twitterHandle: "@getspotcovered",
    i18n: {
        locales: ["en-US"],
        defaultLocale: "en-US"
    },
    quoteUnderwriter: "ptz-us",
    underwritingLink: "/underwriting",
    alternateLanguageSites: [{ origin: "https://spotpetinsurance.ca", locales: ["en-CA"], country: "Canada" }],
    streetAddress: "100 Biscayne Blvd, Suite 400",
    addressLocality: "Miami",
    addressRegion: "FL",
    postalCode: "33132",
    countryCode: "US",
    languageCode: "en",
    country: "United States",
    currency: "USD",
    referralProgram: true,
    samplePolicyLink: "https://spotpet.com/sample-policy",
    productionUrl: "https://spotpet.com",
    // TODO: remove or refactor this into an array of objects that can be used in the <Socials /> component
    socials: {
        instagram: "https://www.instagram.com/getspotcovered",
        facebook: "https://www.facebook.com/getspotcovered",
        linkedin: "https://www.linkedin.com/company/spot-pet-insurance/",
        tiktok: "https://www.tiktok.com/@getspotcovered?lang=en",
        twitter: "https://twitter.com/getspotcovered",
        youtube: "https://www.youtube.com/@getspotcovered"
    },
    trustPilot: {
        apiKey: "KIgtJSyOFkz8hgPWmxLJJsa2vj9A5GmA",
        businessUnitId: "62e828a015be0d5057f853c0",
        url: "https://www.trustpilot.com/review/spotpet.com?amp;stars=5&stars=4"
    },
    useEmailForValidation: false,
    validationMessages: {
        labelText: {
            default: "Enter your Account ID",
            accountAccessPreferred: "Enter your Account ID"
        },
        errorText: {
            default: "Please check your Account ID",
            accountAccessPreferred: "Please check your Account ID"
        }
    },
    quoteIdCookieKey: "quoteIdPtzUs",
    quoteAttributesCookieKey: "quoteAttributesPtzUs",
    canShowQuoteWidget: true
};

module.exports = siteConfig;
